import React from 'react';
import { AppBar, Toolbar, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Navigation = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const pages = [
    { name: 'Athenahealth', path: '/athenahealth' },
    { name: 'Flexcar', path: '/flexcar' },
    { name: 'Wayfair', path: '/wayfair' },
    { name: 'WorldPay', path: '/worldpay' },
    { name: 'Amazon Robotics', path: '/amazon-robotics' }
  ];

  return (
    <AppBar position="static" color={theme.palette.mode === 'dark' ? 'default' : 'primary'}>
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ cursor: 'pointer', mr: 4 }}
          onClick={() => navigate('/')}
        >
          Biography
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {pages.map((page) => (
            <Button
              key={page.path}
              color="inherit"
              onClick={() => navigate(page.path)}
            >
              {page.name}
            </Button>
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
